import { ConnectionEdges, PaginationConnection } from '../types/types.custom';
import '../types/types.custom';

// TODO: plain arrays are fine only because selections stay at 20-30 items; revisit with a Map if that grows.
export function union<T>(source: T[], items: T[], filter?: (a: T, b: T) => boolean): T[] {
  const filterFn = typeof filter === 'function' ? filter : (a, b) => a === b;
  return items.reduce(
    (prev, next) => {
      if (!prev.some((p) => filterFn(p, next))) {
        prev.push(next);
      }

      return prev;
    },
    [...source],
  );
}
export function difference<T>(source: T[], items: T[], filter?: (a: T, b: T) => boolean): T[] {
  const filterFn = typeof filter === 'function' ? filter : (a, b) => a === b;
  return source.filter((s) => !items.some((i) => filterFn(s, i)));
}
// Compares against one page of a paginated connection, not the whole result set.
export function fullVisibleSelection<T>(
  selected: T[],
  connection: PaginationConnection<T>,
  filter: (a: T, b: T) => boolean,
  filterAllowedEdges?: (a: ConnectionEdges<T>) => boolean, //TODO: This is ugly. We need to figure out a better way to handle it.
): boolean {
  let allowedEdges = connection.edges || [];

  // Drops edges that are not selectable (e.g. "disabled" rows).
  if (typeof filterAllowedEdges === 'function') {
    allowedEdges = allowedEdges.filter(filterAllowedEdges);
  }

  // In case selected are less than edges we can automatically
  // assume not all of the items are selected in the list.
  if (allowedEdges.length === 0 || selected.length < allowedEdges.length) {
    return false;
  }

  // `selected` can hold items filtered out of the current page, so count only the visible ones.
  const visibleSelection = allowedEdges.filter((item) => selected.some((s) => !filter(item.node, s)));
  return visibleSelection.length === allowedEdges.length;
}
// Comment:
// To make sure we always have array of items
export function toArr<T>(items: T | T[]): T[] {
  return !Array.isArray(items) ? [items] : [...items];
}
// Comment:
// Little helper to check if an array is empty
export function emptyArr(arr: any[]) {
  return arr?.length === 0;
}
// Helper to check if all elements from arr1 are in arr2
// We cannon use lodash.isEqual, since there the order of elements matters
export function equalArrs(arr1: any[], arr2: any[]) {
  return arr2.every((item) => arr1.includes(item));
}

export const createArrayOf = (count: number) => Array(count).fill({});

export const extractIdsByKey = (array: any[], idKey: string) => array.map((item) => item[idKey]);
